/* eslint-disable */
/**
 * @note This is an auto-generated file. Do not modify it directly.
 * @see https://devdocs.transfix.io/graphql
 *
 * If you need to update the hooks or definitions in this file:
 * 1. Edit the .graphql file in this directory with the same name
 * 2. Run `npm run generate:graphql:mp` in the terminal
 */

import * as Types from '../../../types/graphqlTypes'

import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'
const defaultOptions = {}
export type ITrackingContextCardQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']
}>

export type ITrackingContextCardQuery = { __typename?: 'Query' } & {
  trackingOverview: { __typename?: 'TrackingOverview' } & Pick<
    Types.ITrackingOverview,
    'carrierApplicationId' | 'trackingRequirement' | 'calculatedTrackingMethod'
  > & {
      calculatedTrackingMethodLatestPing?: Types.Maybe<
        { __typename?: 'DriverLocation' } & Pick<
          Types.IDriverLocation,
          'isRecent' | 'phoneTimestamp' | 'sourceType' | 'timezone' | 'id'
        >
      >
      driver?: Types.Maybe<
        { __typename?: 'User' } & Pick<
          Types.IUser,
          'id' | 'parentUserId' | 'fullName' | 'phone' | 'cellPhone'
        >
      >
      carrierAssignment?: Types.Maybe<
        { __typename?: 'CarrierAssignment' } & Pick<Types.ICarrierAssignment, 'id'>
      >
      dispatcher?: Types.Maybe<
        { __typename?: 'User' } & Pick<
          Types.IUser,
          'id' | 'parentUserId' | 'fullName' | 'phone' | 'email'
        >
      >
      driverLatestPing?: Types.Maybe<
        { __typename?: 'DriverLocation' } & Pick<
          Types.IDriverLocation,
          'id' | 'isRecent' | 'phoneTimestamp' | 'timezone'
        >
      >
      eldTruckNumber?: Types.Maybe<
        { __typename?: 'EldTruckNumber' } & Pick<
          Types.IEldTruckNumber,
          'keepTruckinValidated' | 'project44Validated' | 'value'
        >
      >
      trackingCapabilities: { __typename?: 'TrackingCapabilities' } & Pick<
        Types.ITrackingCapabilities,
        'keepTruckin' | 'mobile' | 'project44'
      >
    }
}

export const TrackingContextCardDocument = gql`
  query TrackingContextCard($id: ID!) {
    trackingOverview(shipmentId: $id) {
      calculatedTrackingMethodLatestPing {
        isRecent
        phoneTimestamp
        sourceType
        timezone
        id
      }
      driver {
        id
        parentUserId
        fullName
        phone
        cellPhone
      }
      carrierApplicationId
      carrierAssignment {
        id
      }
      dispatcher {
        id
        parentUserId
        fullName
        phone
        email
      }
      driverLatestPing {
        id
        isRecent
        phoneTimestamp
        timezone
      }
      eldTruckNumber {
        keepTruckinValidated
        project44Validated
        value
      }
      trackingCapabilities {
        keepTruckin
        mobile
        project44
      }
      trackingRequirement
      calculatedTrackingMethod
    }
  }
`

/**
 * __useTrackingContextCardQuery__
 *
 * To run a query within a React component, call `useTrackingContextCardQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrackingContextCardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrackingContextCardQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTrackingContextCardQuery(
  baseOptions: Apollo.QueryHookOptions<
    ITrackingContextCardQuery,
    ITrackingContextCardQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ITrackingContextCardQuery, ITrackingContextCardQueryVariables>(
    TrackingContextCardDocument,
    options
  )
}
export function useTrackingContextCardLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ITrackingContextCardQuery,
    ITrackingContextCardQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ITrackingContextCardQuery, ITrackingContextCardQueryVariables>(
    TrackingContextCardDocument,
    options
  )
}
export type TrackingContextCardQueryHookResult = ReturnType<typeof useTrackingContextCardQuery>
export type TrackingContextCardLazyQueryHookResult = ReturnType<
  typeof useTrackingContextCardLazyQuery
>
export type TrackingContextCardQueryResult = Apollo.QueryResult<
  ITrackingContextCardQuery,
  ITrackingContextCardQueryVariables
>
